(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["descubra-tamanho"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(root){
    if(root.hasAttribute('data-mira-init'))return; root.setAttribute('data-mira-init','1');
    var overlay=root.querySelector('[data-overlay]');
    if(overlay){ var _id=overlay.getAttribute('data-ov-id'); if(_id){ var _o=document.body.querySelector('.mira-rs__overlay[data-ov-id="'+_id+'"]'); if(_o&&_o!==overlay)_o.remove(); } if(overlay.parentElement!==document.body) document.body.appendChild(overlay); }
    var q=function(s){return overlay.querySelector(s)}, qa=function(s){return overlay.querySelectorAll(s)};
    var panel=overlay.querySelector('.mira-rs__panel'), backBtn=q('[data-back]');
    var screens=overlay.querySelectorAll('.mira-rs__screen');
    var MODE=root.dataset.mode||'anel', pdf=root.dataset.pdf||'#';
    var OFFSET=parseFloat(root.dataset.aroOffset||'40');
    var AMIN=parseInt(root.dataset.aroMin||'7'), AMAX=parseInt(root.dataset.aroMax||'29');
    var pxPerMm=null, current={size:null,dia:null}, history=[];

    // textos por modo
    if(MODE==='piercing'){
      q('[data-choose-h]').textContent='Como você quer medir?';
      q('[data-choose-sub]').textContent='Meça na tela ou imprima o guia — o que for melhor pra você.';
      q('[data-primlbl]').textContent='Diâmetro interno';
      q('[data-seclbl]').style.display='none';
      q('[data-measure-hint]').textContent='Coloque a argola sobre o círculo e ajuste até a borda interna coincidir.';
    }

    function show(name,push){
      screens.forEach(function(s){s.classList.toggle('is-active',s.dataset.screen===name)});
      if(push!==false) history.push(name);
      backBtn.style.visibility=history.length>1?'visible':'hidden';
      if(panel) panel.scrollTop=0;
      if(name==='calibrate') applyCard();
      if(name==='measure'){ var r=q('[data-ringsize]'); if(r.dataset.set!=='1'){r.value=(MODE==='piercing'?9:17);r.dataset.set='1';} drawMeasure(); }
    }
    function open(){overlay.classList.add('is-open');history=[];show('choose')}
    function close(){overlay.classList.remove('is-open')}
    root.querySelector('[data-open]').addEventListener('click',open);
    qa('[data-close]').forEach(function(b){b.addEventListener('click',close)});
    overlay.addEventListener('click',function(e){if(e.target===overlay)close()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&overlay.classList.contains('is-open'))close()});
    backBtn.addEventListener('click',function(){history.pop();show(history[history.length-1]||'choose',false)});
    qa('[data-goto]').forEach(function(b){b.addEventListener('click',function(){show(b.dataset.goto)})});
    qa('[data-print]').forEach(function(b){b.addEventListener('click',function(){window.open(pdf,'_blank')})});

    /* calibração: cartão DEITADO, altura = 54 mm (aresta curta) */
    var CARD_REF=54;
    var cardEl=q('[data-card]'), calIn=q('[data-cal]'), grip=q('[data-grip]');
    var MINH=90, MAXH=320;
    function setHeight(px){px=Math.max(MINH,Math.min(MAXH,px));cardEl.style.height=px+'px';calIn.value=px;pxPerMm=px/CARD_REF;}
    function applyCard(){setHeight(parseFloat(calIn.value));}
    calIn.addEventListener('input',function(){setHeight(parseFloat(calIn.value))});
    var drag=null;
    function down(e){drag={y:(e.touches?e.touches[0].clientY:e.clientY),h:cardEl.offsetHeight};e.preventDefault()}
    function move(e){if(!drag)return;var y=(e.touches?e.touches[0].clientY:e.clientY);setHeight(drag.h+(y-drag.y));e.preventDefault()}
    function up(){drag=null}
    grip.addEventListener('mousedown',down);grip.addEventListener('touchstart',down,{passive:false});
    document.addEventListener('mousemove',move);document.addEventListener('touchmove',move,{passive:false});
    document.addEventListener('mouseup',up);document.addEventListener('touchend',up);

    /* medir */
    var ringEl=q('[data-ring]'), ringIn=q('[data-ringsize]'), primV=q('[data-primval]'), secV=q('[data-secval]');
    function aroFromDia(d){return Math.round(Math.PI*d-OFFSET);}
    function fmt(n){return n.toFixed(1).replace('.',',');}
    function drawMeasure(){
      if(!pxPerMm) pxPerMm=3.4;
      var dia=parseFloat(ringIn.value), px=dia*pxPerMm;
      ringEl.style.width=px+'px'; ringEl.style.height=px+'px';
      if(MODE==='piercing'){ current={size:Math.round(dia),dia:dia}; primV.textContent=fmt(dia)+' mm'; }
      else{ var aro=aroFromDia(dia); current={size:aro,dia:dia}; primV.textContent=(aro<AMIN||aro>AMAX)?aro+'*':aro; secV.textContent=fmt(dia)+' mm'; }
    }
    ringIn.addEventListener('input',drawMeasure);

    /* resultado */
    var finalEl=q('[data-final]'), finalDia=q('[data-finaldia]'), okMsg=q('[data-okmsg]'), tipText=q('[data-tiptext]');
    function goResult(){
      okMsg.classList.remove('show');
      if(MODE==='piercing'){
        finalEl.textContent=fmt(current.dia)+' mm';
        finalDia.textContent='diâmetro interno da argola';
        tipText.textContent='Considere a distância do seu furo até a borda do nariz, e se prefere a peça mais rente ou mais afastada.';
      }else{
        finalEl.textContent=current.size;
        finalDia.textContent=current.dia?fmt(current.dia)+' mm de diâmetro':'';
        tipText.textContent='Em dúvida entre dois números? Vá no maior — dá pra ajustar pra menor sem perder material.';
      }
      show('result');
    }
    q('[data-result]').addEventListener('click',goResult);
    q('[data-result-paper]').addEventListener('click',function(){
      var cm=parseFloat((q('[data-cm]').value||'').replace(',','.'));
      if(!cm||cm<3||cm>10){q('[data-cm]').focus();return;}
      var circ=cm*10; current={size:Math.round(circ-OFFSET),dia:circ/Math.PI}; goResult();
    });

    q('[data-use]').addEventListener('click',function(){
      var val = MODE==='piercing' ? Math.round(current.dia) : current.size;
      var done=selectVariant(val);
      var label = MODE==='piercing' ? (val+' mm') : ('aro '+val);
      okMsg.textContent=done?('Tamanho selecionado no produto.'):('Seu tamanho é '+label+'.');
      okMsg.classList.add('show');
    });
    function selectVariant(val){
      var t=String(val), re=new RegExp('(^|\\D)'+t+'(\\D|$)');
      var sels=document.querySelectorAll('select');
      for(var i=0;i<sels.length;i++){
        var opt=[].find.call(sels[i].options,function(o){var x=o.textContent.trim();return x===t||re.test(x)});
        if(opt){sels[i].value=opt.value;sels[i].dispatchEvent(new Event('change',{bubbles:true}));return true;}
      }
      return false;
    }
    applyCard();
  }
  function initAll(){document.querySelectorAll('.mira-rs').forEach(init);}
  if(document.readyState!=='loading')initAll();else document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',initAll);
  document.addEventListener('shopify:block:select',initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
